import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'font-pp-neue-montreal inline-flex items-center leading-none tracking-[0.25px] font-normal',
  {
    variants: {
      variant: {
        default: 'text-[#666]',
      },
      size: {
        default: 'text-[16px]',
        sm: 'text-[12px]',
      },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <span data-slot="badge" className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { badgeVariants };
